import React from 'react';
import useRouter from '@/hooks/useRouter';
import User from '@/pages/_common_user/ManageUser';
import useQuery from './useQuery';
import MissingFields from './MissingFields';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { Helmet } from 'react-helmet-async';
import MobileNavigation from '@/pages/manage/MobileNavigation';
import PageHeading from '@/@communityshare/ui/PageHeading';
import Partners from '@/pages/partners-filtered/Partners';
import DateJoined from '@/pages/_common_user/User/DateJoined';
import Filters from '@/forms/filters_unclassified_users';
import queryString from 'query-string';

export default function Layout() {
  const router = useRouter();
  const { location } = router;
  const launch = useDialogLauncher();

  const search = queryString.parse(location.search);

  const PAGE_SIZE = 12;

  const result = useQuery({
    search,
    location,
    PAGE_SIZE
  });

  const csvQuery = useQuery({
    search,
    returnCsvQuery: true
  });

  function onDownload(query) {
    launch(DialogManager.CSVDownload.Config(query));
  }

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Manage: Unclassified Users</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Manage']}
        title="Unclassified Users"
        description={(
          <span>
            This a list of users who have not provided a reason for joining the platform. In
            other words they not an educator or a partner, and will be filtered out of most views
            because of that.
          </span>
        )}
      />
      <Filters router={router} />
      <Partners
        result={result}
        pageSize={PAGE_SIZE}
        row={function(user) {
          return (
            <User key={user.id} user={user}>
              <div className="bg-cs-gray-50 p-4 border-t border-cs-gray-100">
                <div className="grid grid-cols-2">
                  <MissingFields user={user} />
                  <DateJoined user={user} align="right" />
                </div>
              </div>
            </User>
          );
        }}
        csvQuery={function () {
          onDownload(csvQuery);
        }}
      />
    </div>
  );
}
